import { dateAndTimeToDateTime } from '@utils';

import {
  activityTypeIds,
  activityValueTypes,
  mapPersonValuesToDto,
  normalizeAdvancedValues,
  saveActivity$,
} from '../../common';
import { notApplicableCategoryId } from '../constants';

const saveLongCruiseActivity$ = data => {
  const {
    startDate,
    startTime,
    endDate,
    endTime,
    organizationGuid,
    loggedInUserId,
    persons,
    isAdvancedMode,
    basicYouthDays,
    basicAdultDays,
    youthDays,
    adultDays,
    isPersonalActivity = false,
    isDeclined,
  } = data;
  const startDateTime = dateAndTimeToDateTime(startDate, startTime);
  const endDateTime = dateAndTimeToDateTime(endDate, endTime);
  // Change isApproved => false if it was declined
  const isApproved = isDeclined ? false : data.isApproved;
  const personValues = mapPersonValuesToDto({
    persons,
    organizationGuid,
    loggedInUserId,
    isAdvancedMode,
    isApproved,
    isDeclined,
    basicAdultValues: {
      [activityValueTypes.LONG_CRUISE_DAYS]: basicAdultDays,
    },
    basicYouthValues: {
      [activityValueTypes.LONG_CRUISE_DAYS]: basicYouthDays,
    },
    advancedValues: {
      [activityValueTypes.LONG_CRUISE_DAYS]: {
        ...normalizeAdvancedValues(adultDays),
        ...normalizeAdvancedValues(youthDays),
      },
    },
  });

  const processedData = {
    ...data,
    ...personValues,
    activityTypeId: activityTypeIds.LONG_CRUISE,
    categoryId: notApplicableCategoryId,
    startDateTime,
    endDateTime,
    hostOrganizationGuid: organizationGuid,
    isPersonalActivity,
    isEveryChildOrg: false,
  };

  return saveActivity$(processedData);
};

export default {
  saveLongCruiseActivity$,
};
